import { __getHrefAndPath } from "./__get-href-and-path";
import { getPreviousUrlAndCategory } from "./get-previous-url-and-category";

export default function buildCategoryTreeUrl(
  category, categoryAgg, tier0Url, tier0PageType,
  t0Idx,
  query,
  item,
  pageType,
  tiersWithUrls,
  appliedFilters,
  selectedVehicle,
  removeFilterableAttributes,
) {
  const { previousTierUrl, categoryObj, previousTierPageType } = getPreviousUrlAndCategory(category, categoryAgg[t0Idx].tier1s, tier0Url || categoryAgg[t0Idx].url, tier0PageType);
  const { href, asPath } = __getHrefAndPath({
    query,
    item,
    pageType,
    tiersWithUrls,
    appliedFilters,
    category: categoryObj,
    previousTierUrl,
    previousTierPageType,
    selectedVehicle,
    removeFilterableAttributes,
  });
  return { href, asPath };
}
